var render = function (_h,_vm) {var _c=_vm._c;return _c('p',{staticClass:"disclaimer-content__wrapper"},[_vm._v("\n  DISCLAIMER: Finance Magnates™ may be compensated by the advertisers that\n  appear on the website, based on your interaction with the advertisements or\n  advertisers.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }